import React from 'react';
import { BarChart3, CheckCircle2, CreditCard, Car, LayoutGrid, Receipt, ShieldCheck } from 'lucide-react';
const phases = [{
  phase: 'পর্যায় ১',
  when: 'বর্তমান প্রস্তাব',
  status: 'প্রস্তাবিত প্ল্যাটফর্ম',
  current: true,
  items: [{
    icon: ShieldCheck,
    title: 'নোটিশ ডিজিটাইজেশন ও যাচাই প্ল্যাটফর্ম',
    desc: 'AI/OCR, মেকার-চেকার অনুমোদন, QR নোটিশ, নাগরিক যাচাই ও প্রতারণা রিপোর্ট'
  }]
}, {
  phase: 'পর্যায় ২',
  when: 'ভবিষ্যৎ — স্বল্পমেয়াদি',
  status: 'রোডম্যাপ',
  current: false,
  items: [{
    icon: Car,
    title: 'BRTA System Integration',
    desc: 'গাড়ির রেজিস্ট্রেশন ও মালিকের তথ্য স্বয়ংক্রিয় মিলকরণ'
  }, {
    icon: Receipt,
    title: 'e-Challan Integration',
    desc: 'ই-চালান ব্যবস্থার সাথে মামলার তথ্য সমন্বয়'
  }]
}, {
  phase: 'পর্যায় ৩',
  when: 'ভবিষ্যৎ — মধ্যমেয়াদি',
  status: 'রোডম্যাপ',
  current: false,
  items: [{
    icon: CreditCard,
    title: 'Online Fine Payment',
    desc: 'অফিসিয়াল ও নিরাপদ চ্যানেলে অনলাইন জরিমানা পরিশোধ'
  }, {
    icon: BarChart3,
    title: 'Advanced Analytics',
    desc: 'অপরাধের প্রবণতা, হটস্পট ও প্রতারণা প্যাটার্ন বিশ্লেষণ'
  }]
}, {
  phase: 'পর্যায় ৪',
  when: 'ভবিষ্যৎ — দীর্ঘমেয়াদি',
  status: 'রোডম্যাপ',
  current: false,
  items: [{
    icon: LayoutGrid,
    title: 'Additional Citizen Digital Services',
    desc: 'নোটিফিকেশন সাবস্ক্রিপশন, শুনানির সময়সূচি ও অন্যান্য নাগরিক সেবা'
  }]
}];
export function RoadmapContent() {
  return <div data-id="element-623" data-mp="1l66u1jk7m5op">
      <div className="mb-6 rounded-md border border-[#E69A20]/40 bg-[#FDF3E2] px-4 py-3 text-sm text-[#8a5a06]" data-id="element-624" data-mp="1l6gllbkwkkwi">
        পর্যায় ২–৪ এর বৈশিষ্ট্যসমূহ ভবিষ্যৎ সম্প্রসারণ পরিকল্পনা — বর্তমান প্রোটোটাইপে এগুলো চালু নেই।
      </div>
      <ol className="relative grid gap-5 lg:grid-cols-4" data-id="element-625" data-mp="1g8otaggciwrs">
        <div className="absolute left-0 right-0 top-[22px] hidden h-1 rounded bg-slate-200 lg:block" aria-hidden data-id="element-626" data-mp="1g73zwu5rpjvi" />
        {phases.map(p => <li key={p.phase} className="relative" data-id="element-627" data-mp="178rzy1j0h9qe">
            <div className={`relative z-10 mb-4 flex h-11 w-11 items-center justify-center rounded-full border-4 border-white text-white shadow ${p.current ? 'bg-[#16834A]' : 'bg-[#1769AA]'}`} data-id="element-628" data-mp="17al7rk5d1zzz">
              {p.current ? <CheckCircle2 className="h-5 w-5" data-id="element-629" data-mp="3454qe45yz3ek" /> : <span className="text-sm font-bold" data-id="element-630" data-mp="304kuf3x4u5u0">{p.phase.slice(-1)}</span>}
            </div>
            <div className={`rounded-xl border bg-white p-5 ${p.current ? 'border-[#16834A]/50' : 'border-dashed border-[#1769AA]/40'}`} data-id="element-631" data-mp="2v6t2i9whmjpt">
              <div className="flex items-center justify-between" data-id="element-632" data-mp="3rw0fgtj1jki4">
                <h3 className="text-lg font-bold text-[#003B71]" data-id="element-633" data-mp="3nuowh6uo9xiw">{p.phase}</h3>
                <span className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${p.current ? 'bg-[#E7F4EC] text-[#16834A]' : 'bg-[#E8F1FA] text-[#1769AA]'}`} data-id="element-634" data-mp="3ivlqnk6vbn9v">{p.status}</span>
              </div>
              <div className="text-xs text-slate-500" data-id="element-635" data-mp="27gf9oh62wgu6">{p.when}</div>
              <ul className="mt-4 space-y-4" data-id="element-636" data-mp="27elzwt065ghy">
                {p.items.map(it => {
              const Icon = it.icon;
              return <li key={it.title} className="flex gap-3" data-id="element-637" data-mp="1segl9yihumiw">
                      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#F4F7FB] text-[#003B71]" data-id="element-638" data-mp="1xcrty5x1yqzj"><Icon className="h-5 w-5" data-id="element-639" data-mp="22c4q5h9tdaes" /></span>
                      <div data-id="element-640" data-mp="22aa1brvf8y5f"><div className="text-sm font-semibold" data-id="element-641" data-mp="22ajx5w35dzj1">{it.title}</div><div className="text-xs leading-relaxed text-slate-600" data-id="element-642" data-mp="27335adj2g2gg">{it.desc}</div></div>
                    </li>;
            })}
              </ul>
            </div>
          </li>)}
      </ol>
    </div>;
}